import { Input } from "@/components/ui/input";

interface CreditCardFormProps {
  cardNumber: string;
  cardExpiry?: string;
  cardCvv?: string;
  onCardNumberChange: (value: string) => void;
  onCardExpiryChange?: (value: string) => void;
  onCardCvvChange?: (value: string) => void;
}

export const CreditCardForm = ({ 
  cardNumber, 
  cardExpiry = "", 
  cardCvv = "",
  onCardNumberChange,
  onCardExpiryChange,
  onCardCvvChange
}: CreditCardFormProps) => {
  return (
    <div className="space-y-4">
      <Input
        type="text"
        placeholder="Card Number"
        value={cardNumber}
        onChange={(e) => onCardNumberChange(e.target.value)}
        className="w-full border-[#E5DEFF] focus:ring-[#9b87f5] h-14"
        maxLength={19}
      />
      <div className="grid grid-cols-2 gap-4">
        <Input
          type="text"
          placeholder="MM/YY"
          value={cardExpiry}
          onChange={(e) => onCardExpiryChange?.(e.target.value)}
          className="border-[#E5DEFF] focus:ring-[#9b87f5] h-14"
          maxLength={5}
        />
        <Input
          type="password"
          placeholder="CVV"
          value={cardCvv}
          onChange={(e) => onCardCvvChange?.(e.target.value)}
          className="border-[#E5DEFF] focus:ring-[#9b87f5] h-14"
          maxLength={4}
        />
      </div>
    </div>
  );
};